import React from 'react'
import Chart from './Chart'

/*
function insertDelimiterAt(text, delimAt = 25, delimiter = `<br>`) {
  if (!text || text.length === 0) return text;
  
  let textWords = text.split(` `)

  let charsSinceLastDelim = 0
  let index = 0
  while (index < textWords.length) {
    let word = textWords[index]
    charsSinceLastDelim += word.length + 1 // +1 for the space

    if (charsSinceLastDelim >= delimAt) {
      charsSinceLastDelim = 0
      textWords.splice(index, 0, delimiter)
    }

    index++
  }

  return textWords.join(` `)
}
*/  

function insertDelimiterAt(text, delimAt = 25, delimiter = `<br>`) {
  if (!text || text.length === 0) return text;

  const words = text.split(` `);
  const lines = [];
  let currentLine = [];
  let currentLength = 0;

  for (let word of words) {
    // If the current line has words AND adding the next word exceeds the limit, 
    // push the current line and start a new one.
    if (currentLine.length > 0 && currentLength + word.length >= delimAt) {
      lines.push(currentLine.join(` `));
      currentLine = [word];
      currentLength = word.length + 1; // +1 for the space
    } else {
      currentLine.push(word);
      currentLength += word.length + 1;
    }
  }

  // Push the final remaining line
  if (currentLine.length > 0) {
    lines.push(currentLine.join(` `));
  }

  return lines.join(delimiter);
}

export default function ParetoChart({data = {}, layout = {height: 800}}) {

  const entries = Object.entries(data)

  
  entries.sort((a, b) => {
    if (a[1] === b[1]) return 0
    else if (a[1] < b[1]) return 1
    else return -1
  })
  
  console.log('Initial entries:', entries)
  let x = []
  const y = []

  for (let [xVal, yVal] of entries) {
    x.push(xVal)
    y.push(yVal)
  }

  // Add padding for better line coverage, but use empty string for minimal gap
 /*  const padLabelStart = '';
  const padLabelEnd = '';
  x = [padLabelStart, ...x, padLabelEnd]; */
  y.unshift(0);
  y.push(0);

  //Make the labels look good
  x = x.map((label) => insertDelimiterAt(label))

  const total = y.reduce((a, c) => a + c, 0)
  let intermediate = 0
  // Calculate percentages only for the real data (excluding the padding)
  const percentages = y.map((v, i) => {
    if (i === 0) return 0;
    if (i === y.length - 1) return 100;
    intermediate = intermediate + v;
    return (intermediate / (total - y[0] - y[y.length - 1])) * 100;
  })

  const graphData = [
    {
      x,
      y,
      name: 'Number of Failures',
      type: `bar`,
      yaxis: 'y2',
    },
    {
      x,
      y: percentages,
      name: 'Cumulative %',
      type: `scatter`,
      mode: 'lines+markers',
      yaxis: 'y1',
      line: { color: 'red', width: 3 },
    },
  ]

  const graphLayout = {
    // Remove grid, overlay yaxes
    yaxis: {
      title: `Percentage of Failures`,
      side: `right`,
      overlaying: 'y2',
      showgrid: false,
      tickformat: '.0f',
      rangemode: 'tozero',
      range: [0, 100],
      tickfont: { color: 'red' },
      titlefont: { color: 'red' },
    },
    yaxis2: {
      title: `Number of Failures`,
      side: 'left',
      showgrid: true,
      zeroline: true,
      rangemode: 'tozero',
      tickfont: { color: 'black' },
      titlefont: { color: 'black' },
    },
    xaxis: {
      tickangle: 0,
      automargin: true,
      tickfont: {
        size: 10
      },
      range: [0.75, x.length - 1.25], // clip whitespace at both ends
    },
    margin: {
      b: 200, 
      l: 80,
      r: 80,
      t: 50
    },
    showlegend: false,
    paper_bgcolor: 'rgba(0,0,0,0)',
    plot_bgcolor: 'rgba(0,0,0,0)',
    ...layout,
  }  
  const calculatedLayout = {...graphLayout};
  // Replace hasOwnProperty with Object.prototype.hasOwnProperty.call
  if (!Object.prototype.hasOwnProperty.call(layout, 'width')) {
    // Based on observation: 8 labels fit in 1400px width
    // So each label needs approximately 175px (1400/8)
    const pixelsPerLabel = 175;
    const dynamicWidth = Math.max(Math.ceil(entries.length * pixelsPerLabel * 1.1), 1400);    
    calculatedLayout.width = dynamicWidth;
  }

  // Wrap chart in a scrollable container

  console.log('Final graph data:', graphData)
  console.log('Final graph layout:', calculatedLayout)

  return (
    <div style={{ 
      overflowX: 'auto',
      width: '100%', 
      maxWidth: '100%',
      margin: 'auto'
    }}>
      <Chart options={graphData} layout={calculatedLayout} style={{margin: 'auto'}} />
    </div>
  );
}
